const Instagram = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="25"
    viewBox="0 0 24 25"
    fill="none"
  >
    <path
      d="M17 2.9502H7C4.23858 2.9502 2 5.18877 2 7.95019V17.9502C2 20.7116 4.23858 22.9502 7 22.9502H17C19.7614 22.9502 22 20.7116 22 17.9502V7.95019C22 5.18877 19.7614 2.9502 17 2.9502Z"
      stroke="white"
      strokeWidth="1.09134"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16.0017 12.3205C16.1251 13.1527 15.9829 14.0027 15.5954 14.7495C15.2079 15.4963 14.5948 16.1019 13.8433 16.4802C13.0918 16.8584 12.2401 16.9901 11.4094 16.8564C10.5788 16.7228 9.81142 16.3306 9.2165 15.7357C8.62158 15.1407 8.22939 14.3734 8.09573 13.5427C7.96206 12.712 8.09373 11.8604 8.47199 11.1089C8.85025 10.3574 9.45585 9.74424 10.2026 9.35674C10.9494 8.96924 11.7994 8.82709 12.6317 8.9505C13.4806 9.07638 14.2665 9.47196 14.8734 10.0788C15.4802 10.6856 15.8758 11.4716 16.0017 12.3205Z"
      stroke="white"
      strokeWidth="1.09134"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17.5 7.44971H17.5105"
      stroke="white"
      strokeWidth="1.09134"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export default Instagram
